export default "__VITE_ASSET__DY3KQvba__"